//1. EVENT SEARCH
export const SEARCH_DATA = "SEARCH_DATA";
export const SEARCH_DATA_CLEAR = "SEARCH_DATA_CLEAR";
export const SEARCH_RESULT = "SEARCH_RESULT";
